var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoting = function SvgVoting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4BCD0",
    d: "M15.5 11h-1.268l1.732-3a1 1 0 0 0-.366-1.366L13 5.134a1 1 0 0 0-1.366.366l-2.5 4.33A1 1 0 0 0 9.257 11H8.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1m-3-5 2.598 1.5-2.02 3.5H11.16L10 10.33zm4.037 3-.577 1h.54l2.25 3H5.25l2.25-3h.406q.03-.087.078-.17l.48-.83H7.5a1 1 0 0 0-.8.4l-2.5 3.333a1 1 0 0 0-.2.6V18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4.667a1 1 0 0 0-.2-.6L17.3 9.4a1 1 0 0 0-.763-.4"
  })));
};
export default SvgVoting;